// Console shell: navigation, sign-in, user menu, invite page.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const consoleShellEn: Readonly<Record<string, string>> = {
  // Shell and navigation
  'انتقل إلى المحتوى': 'Skip to content',
  'أقسام لوحة العمل': 'Console sections',
  'لوحة اليوم': 'Dashboard',
  'الوضع الفاتح': 'Light mode',
  'الوضع الداكن': 'Dark mode',
  'تسجيل الخروج': 'Sign out',
  'تعذّر تسجيل الخروج. حاول مجدداً.': 'Could not sign out. Try again.',
  'مسار EV · لوحة العمل': 'Masar EV · Console',
  'مسار EV': 'Masar EV',
  'مسار EV لتأجير السيارات': 'Masar EV Car Rental',
  // Route states
  'لا تملك صلاحية هذه الصفحة': 'You do not have access to this page',
  'حدث خطأ غير متوقع': 'Something went wrong',
  'إعادة تحميل الصفحة': 'Reload the page',
  'الصفحة غير موجودة': 'Page not found',
  'تحقق من الرابط أو اختر صفحة من القائمة.': 'Check the link or choose a page from the menu.',
  // Sign-in
  'تسجيل الدخول': 'Sign in',
  'تسجيل الدخول إلى لوحة العمل': 'Sign in to the console',
  'لفريق مسار EV فقط. استخدم اسم المستخدم وكلمة المرور الخاصة بك.':
    'For the Masar EV team only. Use your own username and password.',
  'انتهت صلاحية محاولة الدخول. حاول مجدداً.': 'The sign-in attempt expired. Try again.',
  'تعذّر تسجيل الدخول. حاول مجدداً.': 'Could not sign in. Try again.',
  'أُلغي تسجيل الدخول': 'Sign-in was cancelled',
  'خدمة تسجيل الدخول غير متاحة الآن. حاول بعد قليل.':
    'The sign-in service is not available right now. Try again shortly.',
  'هذا الحساب غير مرتبط بعضو في الفريق. تواصل مع المالك.':
    'This account is not linked to a team member. Contact the owner.',
  'هذا الحساب موقوف. تواصل مع المالك.': 'This account is disabled. Contact the owner.',
  'أكمل دعوتك أولاً من الرابط الذي وصلك على واتساب.':
    'Finish your invitation first, from the link you received on WhatsApp.',
  // Invitation
  أهلاً: 'Welcome',
  'اختر كلمة مرور لحسابك': 'Choose a password for your account',
  'كلمة المرور': 'Password',
  'تأكيد كلمة المرور': 'Confirm password',
  'حفظ كلمة المرور': 'Save password',
  'كلمة المرور 12 حرفاً على الأقل': 'The password needs at least 12 characters',
  '12 حرفاً على الأقل، ولا تكون اسم المستخدم': 'At least 12 characters, and not your username',
  'كلمتا المرور غير متطابقتين': 'The passwords do not match',
  'رابط الدعوة غير صالح': 'This invitation link is not valid',
  'افتح الرابط كما وصلك على واتساب، أو اطلب من المالك إرسال دعوة جديدة.':
    'Open the link exactly as you received it on WhatsApp, or ask the owner to send a new invitation.',
  'تم تعيين كلمة المرور': 'Your password is set',
  'يمكنك الآن تسجيل الدخول باسم المستخدم وكلمة المرور الجديدة.':
    'You can now sign in with your username and your new password.',
};
